<template>
    <!-- GALLERY -->
    <section class="gallery" id="gallery">
        <div class="container">
            <!-- Section Header -->
            <div class="section-header">
                <h2 class="section-title">Галерея</h2>
                <h3 class="section-subtitle">Современный удобный дизайн адаптированный под все распространенные устройства</h3>
            </div>
            <!-- End Section Header -->
            <!-- Section Content -->
            <div class="r1 row animateblock btt speed-1">
                <slick class="c1 col-md-12" id="gallery-carousel-1" :options="slickOptions">

                    <div class="link-modal">
                        <img class="img-responsive thumb" src="landing/static/images/gallery/gallery_item_1.png"
                             alt="Screenshot 1">
                    </div>


                    <div class="link-modal">
                        <img class="img-responsive thumb" src="landing/static/images/gallery/gallery_item_1.png"
                             alt="Screenshot 2">
                    </div>


                    <div class="link-modal">
                        <img class="img-responsive thumb" src="landing/static/images/gallery/gallery_item_1.png"
                             alt="Screenshot 3">
                    </div>


                    <div class="link-modal">
                        <img class="img-responsive thumb" src="landing/static/images/gallery/gallery_item_1.png"
                             alt="Screenshot 1">
                    </div>


                    <div class="link-modal">
                        <img class="img-responsive thumb" src="landing/static/images/gallery/gallery_item_1.png"
                             alt="Screenshot 2">
                    </div>


                    <div class="link-modal">
                        <img class="img-responsive thumb" src="landing/static/images/gallery/gallery_item_1.png"
                             alt="Screenshot 3">
                    </div>

                </slick>
            </div>
            <!-- End Section Content -->
        </div>
    </section>
    <!-- END GALLERY -->
</template>

<script>
    import Slick from 'vue-slick';

    export default {
        name: "Gallery",
        components: {
            Slick,
        },
        data() {
            return {
                slickOptions: {
                    slidesToShow: 3,
                    centerMode: true,
                    centerPadding: '0',
                    infinite: false,
                    initialSlide: 3,
                    slidesPerRow: 1,
                    speed: 300,
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                centerMode: false,
                            }
                        }
                    ]
                },
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Gallery.vue?4ea90516